(() => {
  const initBestLens = (root) => {
    const blocks = root.querySelectorAll('.custom-best-lens__drag');

    blocks.forEach((block) => {
      if (block.dataset.initialized === 'true') {
        return;
      }

      const getLensRadius = () => {
        const dragger = block.querySelector('.custom-best-lens__dragger');
        const draggerRect = dragger?.getBoundingClientRect();

        if (!draggerRect) {
          return 0;
        }

        return Math.max(draggerRect.width, draggerRect.height) / 2;
      };

      const clampLensPosition = (x, y) => {
        const rect = block.getBoundingClientRect();
        const radius = getLensRadius();
        const maxX = Math.max(radius, rect.width - radius);
        const maxY = Math.max(radius, rect.height - radius);

        return {
          x: Math.max(radius, Math.min(maxX, x)),
          y: Math.max(radius, Math.min(maxY, y)),
        };
      };

      const setLensPosition = (x, y) => {
        const position = clampLensPosition(x, y);

        block.style.setProperty('--lens-x', `${position.x}px`);
        block.style.setProperty('--lens-y', `${position.y}px`);
      };

      const updateLens = (clientX, clientY) => {
        const rect = block.getBoundingClientRect();

        setLensPosition(clientX - rect.left, clientY - rect.top);
      };

      const centerLens = () => {
        const rect = block.getBoundingClientRect();

        setLensPosition(Math.round(rect.width * 0.72), Math.round(rect.height * 0.28));
      };

      block.dataset.initialized = 'true';
      block.addEventListener('pointerenter', (event) => updateLens(event.clientX, event.clientY));
      block.addEventListener('pointermove', (event) => updateLens(event.clientX, event.clientY));
      window.addEventListener('resize', centerLens);
      centerLens();
    });
  };

  document.addEventListener('DOMContentLoaded', () => initBestLens(document));
  document.addEventListener('shopify:section:load', (event) => initBestLens(event.target));
})();
